module.exports = __webpack_public_path__ + "img/apple.96a80ace.svg";